define('StellarGrade.ST_NewsletterForm.NewsletterForm', ['StellarGrade.ST_NewsletterForm.NewsletterForm.View', 'jQuery'], function (NewsletterFormView, $) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            /** @type {LayoutComponent} */
            var layout = container.getComponent('Layout');
            const currentUrl = window.location.href;
            if (layout) {
                layout.addChildView('Footer', function () {
                    return new NewsletterFormView({ container: container });
                });
            }
        },
    };
});
